<div class="login-shell">

  <!-- ===== Left brand panel ===== -->
  <aside class="brand-panel">
    <img class="brand-logo" alt="Home Clause" src="assets/logos/symbol3.svg" fetchpriority="high" />
  </aside>

  <!-- ===== Right form panel ===== -->
  <main class="form-panel">
    <div class="card">

      @if (!mfaRequired && !mfaSetupRequired) {
        <h2>{{ 'login.title' | translate }}</h2>
        <p class="subtitle">{{ 'login.subtitle' | translate }}</p>

        <form [formGroup]="loginForm" (ngSubmit)="login()">

          <div class="field"
               [class.invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
            <input id="email"
                   type="email"
                   formControlName="email"
                   placeholder="{{ 'login.email' | translate }}"
                   autocomplete="email" />
            <label for="email">{{ 'login.email' | translate }}</label>
          </div>

          <div class="field"
               [class.invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
            <input id="password"
                   formControlName="password"
                   [attr.type]="cleartext ? 'text' : 'password'"
                   placeholder="{{ 'login.password' | translate }}"
                   autocomplete="current-password" />
            <label for="password">{{ 'login.password' | translate }}</label>
            <button type="button"
                    class="eye-btn"
                    [attr.aria-label]="'login.show-password' | translate"
                    [attr.aria-pressed]="cleartext"
                    (click)="togglePassword()">
              <i class="fa-regular" [ngClass]="cleartext ? 'fa-eye-slash' : 'fa-eye'"></i>
            </button>
          </div>

          <button type="submit"
                  class="btn-primary"
                  [class.is-loading]="isLoggingIn"
                  [disabled]="loginForm.invalid || isLoggingIn">
            <span>{{ 'login.connect' | translate }}</span>
          </button>

          <button type="button"
                  class="btn-ghost"
                  [routerLink]="APP_ROUTES.AUTH.PASSWORD_RECOVERY">
            {{ 'login.forgotten-password' | translate }}
          </button>
        </form>
      }

      @else if (mfaRequired) {
        <button type="button" class="back-link" (click)="cancelMfa()">
          <i class="fa-solid fa-chevron-left"></i>
          {{ 'login.mfa.cancel' | translate }}
        </button>

        <h2>{{ 'login.mfa.title' | translate }}</h2>
        <p class="subtitle">{{ 'login.mfa.instruction' | translate }}</p>

        <div class="otp-row" (paste)="onOtpPaste($event)">
          @for (digit of otpDigits; track $index) {
            <input #otpInput
                   type="text"
                   inputmode="numeric"
                   maxlength="1"
                   [class.filled]="otpDigits[$index]"
                   [value]="otpDigits[$index]"
                   (input)="onOtpInput($event, $index)"
                   (keydown)="onOtpKeydown($event, $index)"
                   [attr.aria-label]="'login.mfa.digit' | translate: { index: $index + 1 }" />
          }
        </div>

        <button type="button"
                class="btn-primary mfa-verify"
                (click)="verifyMfaCode()"
                [class.is-loading]="isVerifyingMfa"
                [disabled]="mfaCode.length !== 6 || isVerifyingMfa">
          <span>{{ 'login.mfa.verify' | translate }}</span>
        </button>
      } @else if (mfaSetupRequired) {
        <button type="button" class="back-link" (click)="cancelMfaSetup()">
          <i class="fa-solid fa-chevron-left"></i>
          {{ 'login.mfa.cancel' | translate }}
        </button>

        <h2>{{ 'settings.security.mfa.title' | translate }}</h2>
        <p class="subtitle">{{ 'login.mfa.instruction' | translate }}</p>

        @if (isLoadingSetup){
          <div class="spinner-container">
            <div class="spinner"></div>
          </div>
        }

        @if (!isLoadingSetup && qrCodeUri){
          <div class="mfa-setup">
            <div class="step-label"><span class="n">1</span>{{ 'settings.security.mfa.setup.step1' | translate }}</div>
            <div class="qr-zone"><img [src]="qrCodeUri" alt="MFA QR Code"></div>
            <div class="secret-row">
              {{ 'settings.security.mfa.setup.secret' | translate }}
              <code>{{ manualSecret }}</code>
              <button type="button" class="copy-btn" (click)="copySecret()"
                      title="{{ 'common.copy' | translate }}">
                <i class="far fa-copy"></i>
              </button>
            </div>

            <div class="step-label"><span class="n">2</span>{{ 'settings.security.mfa.setup.step2' | translate }}</div>
            <div class="otp-row" [class.success-overlay]="isSetupSuccess" (paste)="onSetupOtpPaste($event)">
              @if (isSetupSuccess) {
                <div class="otp-success-spinner">
                  <i class="fas fa-circle-check"></i>
                </div>
              }
              @for (digit of setupOtpDigits; track $index) {
                <input #setupOtpInput
                       type="text"
                       inputmode="numeric"
                       maxlength="1"
                       autocomplete="one-time-code"
                       [class.filled]="setupOtpDigits[$index]"
                       [value]="setupOtpDigits[$index]"
                       (input)="onSetupOtpInput($event, $index)"
                       (keydown)="onSetupOtpKeydown($event, $index)"
                       [attr.aria-label]="'login.mfa.digit' | translate: { index: $index + 1 }" />
              }
            </div>

            <button type="button"
                    class="btn-primary mfa-verify"
                    (click)="confirmMfaSetup()"
                    [class.is-loading]="isVerifyingSetup"
                    [disabled]="setupMfaCode.length !== 6 || isVerifyingSetup">
              <span>{{ 'settings.security.mfa.button.verify' | translate }}</span>
            </button>
          </div>
        }
      }

    </div>
  </main>
</div>
